/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { AdminRefundPolicyDto, AdminRefundPolicyRequestDto } from './data-contracts';
import { ContentType, HttpClient, RequestParams } from './http-client';

export class AdminRefundPolicyService<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>;

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }

  /**
   * @description Retrieve a specific refund policy by its ID.
   *
   * @tags AdminRefundPolicyService
   * @name GetRefundPolicy
   * @summary Get Refund Policy by ID
   * @request GET:/v1/admin/refund-policies/{policyId}
   * @secure
   */
  getRefundPolicy = (policyId: number, params: RequestParams = {}) =>
    this.http.request<AdminRefundPolicyDto, any>({
      path: `/v1/admin/refund-policies/${policyId}`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * @description Update an existing refund policy by its ID.
   *
   * @tags AdminRefundPolicyService
   * @name UpdateRefundPolicy
   * @summary Update Refund Policy
   * @request PUT:/v1/admin/refund-policies/{policyId}
   * @secure
   */
  updateRefundPolicy = (
    policyId: number,
    data: AdminRefundPolicyRequestDto,
    params: RequestParams = {},
  ) =>
    this.http.request<AdminRefundPolicyDto, any>({
      path: `/v1/admin/refund-policies/${policyId}`,
      method: 'PUT',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * @description Delete a refund policy by its ID.
   *
   * @tags AdminRefundPolicyService
   * @name DeleteRefundPolicy
   * @summary Delete Refund Policy
   * @request DELETE:/v1/admin/refund-policies/{policyId}
   * @secure
   */
  deleteRefundPolicy = (policyId: number, params: RequestParams = {}) =>
    this.http.request<void, any>({
      path: `/v1/admin/refund-policies/${policyId}`,
      method: 'DELETE',
      secure: true,
      ...params,
    });
  /**
   * @description Retrieve a paginated list of refund policies.
   *
   * @tags AdminRefundPolicyService
   * @name GetRefundPolicies1
   * @summary Get Refund Policies
   * @request GET:/v1/admin/refund-policies
   * @secure
   */
  getRefundPolicies1 = (params: RequestParams = {}) =>
    this.http.request<AdminRefundPolicyDto[], any>({
      path: `/v1/admin/refund-policies`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * @description Create a new refund policy.
   *
   * @tags AdminRefundPolicyService
   * @name CreateRefundPolicy
   * @summary Create Refund Policy
   * @request POST:/v1/admin/refund-policies
   * @secure
   */
  createRefundPolicy = (data: AdminRefundPolicyRequestDto, params: RequestParams = {}) =>
    this.http.request<AdminRefundPolicyDto, any>({
      path: `/v1/admin/refund-policies`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
}
